import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { useCompanyType } from './useCompanyType';
import { CompanyType } from '@/types/company';

/**
 * Hook to check if current company has access to industry-specific features
 * @param requiredDomain - The company type required to access the feature
 * @returns Object with access status, company type, and loading state
 */
export function useIndustryAccess(requiredDomain: CompanyType | CompanyType[]) {
  const { profile, loading: authLoading } = useAuth();
  const companyId = profile?.company_id ? Number(profile.company_id) : null;
  const { companyType, isLoading: companyTypeLoading } = useCompanyType(companyId);

  const hasAccess = useMemo(() => {
    if (!companyType) return false;
    
    const requiredDomains = Array.isArray(requiredDomain) 
      ? requiredDomain 
      : [requiredDomain];
    
    return requiredDomains.includes(companyType);
  }, [companyType, requiredDomain]);

  const isLoading = authLoading || companyTypeLoading;

  return {
    hasAccess,
    companyType,
    companyId,
    isLoading,
    canAccess: hasAccess && !isLoading,
  };
}

